module.exports = __webpack_public_path__ + "img/bread.456f416d.png";